import { CoreObject } from "../geometry/Object";
import { CameraAttribute } from "./CoreCamera";
import { CoreType } from "../Type";
import { ObjType } from "../../engine/poly/registers/nodes/types/Obj";
export class CoreCameraRenderSceneController {
  static isRenderSceneNode(node) {
    return node.type() == ObjType.SCENE;
  }
  static renderScene(options) {
    const { scene, camera } = options;
    let sceneNode;
    const foundNodePath = CoreObject.attribValue(camera, CameraAttribute.RENDER_SCENE_PATH);
    if (foundNodePath && CoreType.isString(foundNodePath)) {
      const foundNode = scene.node(foundNodePath);
      if (foundNode && this.isRenderSceneNode(foundNode)) {
        sceneNode = foundNode;
        return sceneNode.object;
      }
    }
  }
}
